import { REQUEST_TIMEOUT } from 'src/constants/auth';
import { ApiPath } from 'src/enums/apiPath';
import { Company } from 'src/models/company';
import { apiRequest } from 'src/utils/api';

export const getCompanies = async (params: {
  page: number;
  limit: number;
  hide_product_management?: number;
}) => {
  const res = await apiRequest.get({
    url: ApiPath.COMPANY,
    params,
    timeout: REQUEST_TIMEOUT
  });

  return res.data;
};

export const createCompany = async (company: Company) => {
  await apiRequest.post({
    url: ApiPath.COMPANY,
    data: company,
    timeout: REQUEST_TIMEOUT
  });
};

export const getCompanyDetail = async (
  id: number,
  params: { with?: string }
) => {
  const res = await apiRequest.get({
    url: `${ApiPath.COMPANY}/${id}`,
    params,
    timeout: REQUEST_TIMEOUT
  });

  return res.data;
};

export const updateCompany = async (id: number, company: any) => {
  const res = await apiRequest.put({
    url: `${ApiPath.COMPANY}/${id}`,
    data: company,
    timeout: REQUEST_TIMEOUT
  });
  return res;
};

export const deleteCompany = async (id: number) => {
  await apiRequest.delete({
    url: `${ApiPath.COMPANY}/${id}`,
    timeout: REQUEST_TIMEOUT
  });
};

export const createCompanyRegistration = async (payload: any) => {
  const res = await apiRequest.post({
    url: ApiPath.COMPANY_REGISTRATION,
    data: payload,
    timeout: REQUEST_TIMEOUT
  });
  return res;
};

export const revokeCompany = async (id: string, body: any) => {
  await apiRequest.post({
    url: `${ApiPath.COMPANY}/${id}/revoke`,
    data: body,
    timeout: REQUEST_TIMEOUT
  });
};

export const unRevokeCompany = async (id: string) => {
  await apiRequest.post({
    url: `${ApiPath.COMPANY}/${id}/unrevoke`,
    timeout: REQUEST_TIMEOUT
  });
};

export const registerValueChainType = async (id: string, body: any) => {
  await apiRequest.post({
    url: `${ApiPath.COMPANY}/${id}/value-chain-types`,
    data: body,
    timeout: REQUEST_TIMEOUT
  });
};